import { QueryKeys } from "@/infra/query";
import { useAuth, useApi } from "@akina/infra";
import { useQuery } from "@tanstack/react-query";

const PATIENT_DATA_STALE_TIME = 1000 * 60 * 5; // 3min

export const useFetchPatient = (
  params: { throwOnError?: boolean } = {},
) => {
  const { api } = useApi();
  const { isAuthenticated } = useAuth();

  return useQuery({
    queryKey: [QueryKeys.fetchPatient],
    queryFn: async () => {
      return await api.patient.get();
    },
    enabled: isAuthenticated,
    staleTime: PATIENT_DATA_STALE_TIME,
    ...params,
  });
};
